import {
  checkAuthsError,
  checkPeterwittToken,
  getSLT,
  handleAuthResponse,
  handleLogout,
  isLoggedIn,
} from '@sky-uk/ita-js-common-token-manager';

import logger from '../../services/logging/logging-service';
import { authActions } from '../../global-store/subjects/auth';

import { fetchTMApi, logoutCerbero } from './auth-api';

const initAuth = async () => {
  authActions.authStart();

  // User is logged (SLT + RTK tokens exists)
  if (isLoggedIn()) {
    logger.info('[Auth] - User is logged');
    authActions.authEnd(true, getSLT());
    return;
  }

  // User is not logged, PETERWITT token does not exist
  if (!checkPeterwittToken()) {
    logger.info('[Auth] - User is NOT logged');
    authActions.authEnd(false);
    return;
  }

  // User is not logged, PETERWITT token exists, we try to get a new authorization token from TM
  try {
    const httpResponse = await fetchTMApi({
      method: 'POST',
      credentials: 'include',
      data: { application: 'web', type: 'JWTC' },
    });
    const response = await httpResponse.json();

    // Failure
    if (!httpResponse.ok) {
      const error = checkAuthsError(httpResponse?.status, response?.code);
      throw new Error(error);
    }

    // Success
    const { isBlacklisted } = handleAuthResponse(response);
    if (isBlacklisted) {
      throw new Error('User in blacklist');
    } else {
      authActions.authEnd(true, getSLT());
      logger.info('[Auth] - User is logged');
    }
  } catch (error) {
    logger.error('[Auth] cannot get the tokens from TM - ', error);
    await logoutCerbero();
    handleLogout();
    authActions.authEnd(false);
  }
};

export { initAuth };
